"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleProblemDetailError = void 0;
const commons_objects_1 = require("@deliverr/commons-objects");
function handleProblemDetailError(error) {
    var _a, _b;
    const status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
    if (status) {
        const data = (_b = error.response.data) !== null && _b !== void 0 ? _b : {};
        throw new commons_objects_1.DeliverrError({
            code: commons_objects_1.HttpErrorCodes[status] || commons_objects_1.ApiError.UNKNOWN_ERROR,
            message: data.message,
            payload: {
                status: data.status,
                type: data.type,
                title: data.title,
                detail: data.detail,
                instance: data.instance,
            },
        });
    }
    throw new commons_objects_1.DeliverrError({
        code: commons_objects_1.ApiError.UNKNOWN_ERROR,
        payload: error,
    });
}
exports.handleProblemDetailError = handleProblemDetailError;
//# sourceMappingURL=handleProblemDetailError.js.map